import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const LitigationSaveTemplateModal = ({ show, handleClose, templateActive, onSave }) => {
  const [templateName, setTemplateName] = useState("");

  const handleSave = () => {
    if (templateName.trim()) {
      onSave(templateName.trim());
      setTemplateName("");
    }
  };

  const handleCancel = () => {
    setTemplateName("");
    handleClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && templateName.trim()) {
      handleSave();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      dialogClassName="modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="md"
    >
      <div style={{ minHeight: "150px" }}>
        <Modal.Header
          style={{ borderBottom: "0px" }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            {templateActive ? "Update" : "Save"} Litigation Report Template
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0 m-t-5 m-l-5 m-r-5 m-b-5" style={{ minHeight: "100px" }}>
          <div className="custom-tab">
            <div className="row mx-0 align-items-center" style={{ marginBottom: "5px" }}>
              <div className="col-md-12 p-0">
                <div
                  className="m-b-5"
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "var(--primary)",
                  }}
                >
                  Template Name
                </div>
                <input
                  type="text"
                  placeholder={
                    templateActive?.template_name ||
                    "Enter template name (e.g., Active Litigation Cases)"
                  }
                  className="form-control height-25 p-0 p-l-5 rounded-0"
                  onFocus={(e) => {
                    e.target.placeholder = "";
                    e.target.style.color = "black";
                  }}
                  onBlur={(e) => {
                    e.target.placeholder =
                      templateActive?.template_name ||
                      "Enter template name (e.g., Active Litigation Cases)";
                  }}
                  style={{ color: templateName ? "black" : "var(--primary-25)" }}
                  value={templateName}
                  onChange={(e) => setTemplateName(e.target.value)}
                  onKeyPress={handleKeyPress}
                  autoFocus
                />
              </div>
            </div>

            <div className="row mx-0">
              <div className="col-md-12 p-0">
                <div
                  style={{
                    fontSize: "12px",
                    color: "var(--primary-60)",
                    fontStyle: "italic",
                  }}
                >
                  {templateActive
                    ? "Update the current template with your latest settings."
                    : "Save your Duration, Screen By, and Report Values as a reusable template."}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="secondary"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            disabled={!templateName.trim()}
            onClick={handleSave}
          >
            {templateActive ? "Update" : "Save"} Template
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default LitigationSaveTemplateModal;
